module.exports = __webpack_public_path__ + "4b5eb49ed982605bed73c189e57db4.svg";